<div class="bottom">
    <img [src]="backgroundBottom" alt="Swine" class="elanco-bg-bottom" />
</div>
<div>
    <img [src]="eksLogo" style="right: 0px;width: 20%;" alt="Elanco Knowledge Solutions" class="elanco-powered-right" />
</div>

<!-- Copyright -->
<ng-container *ngIf="copyright" >
    <div class="copyright" data-tool="Swine">
        ©{{ currentYear }} Elanco and Company, its affiliates and subsidiaries
    </div>
</ng-container>